const config = {
    razorpayKey:process.env.REACT_APP_RAZORPAY_KEY,
    baseurl :process.env.REACT_APP_BASEURL
    
    };
    module.exports = config;
    